<script>
// import { layoutComputed } from "@/state/store";
import Vertical from "./vertical";

export default {
  components: { Vertical },
  data() {
    return {};
  },
  computed: {
    // ...layoutComputed
  },
  methods: {}
};
</script>

<template>
  <div>
    <vertical layout="vertical">
      <slot />
    </vertical>

  </div>
</template>
